import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Http from '../../../Http'
import ACCESS from '../../../ACCESS.js';
import moment from 'moment';
import { isDate } from '../../../helpers/isDate';
import Toast from 'react-hot-toast';

class EmbarqueGuias extends TableComponent {

  componentDidMount() {
    const id = this.props.id_embarque || null;
    this.tableConfig(
      { dataUrl: `embarque-guia/${id}/filter`, deleteUrl: `embarque-guia/${id}/delete`, deleteField: 'g_folio', modUrl: '' },
      TableOp.Table('', [
        { label: 'Linea', id: 'linea' },
        // { label: 'Letra', id: 'letra' },
        { label: 'Guia', id: 'g_folio' },
        { label: 'Cliente', id: 'cliente' },
        { label: 'Origen', id: 'origen_sucursal' },
        { label: 'Destino', id: 'destino_sucursal' },
      ], [{ id: 'delete', icon: 'delete', tooltip: 'Eliminar del embarque', access: [ACCESS.EMBARQUE.AGREGAR_GUIAS_AL_EMBARQUE, ACCESS.EMBARQUE.AGREGAR_GUIAS_RESTRICCION_SUCURSAL] }]))
    // dejar ese espacio en blanco
    this.table(0, this.rpp, " ", this.orderBy);
  }

  componentDidUpdate(prevprops) {
    if (this.props.add) {
      const { tableData } = this.state;
      let original_rows = tableData.rows.filter(r => !r.nueva)
      tableData.rows = [...this.props.guias ,...original_rows]
      this.rpp = 15;
      this.setState({ tableData: { ...tableData, rows: tableData.rows, total: tableData.rows.length, rpp: 15 } })
      this.props.onAdd();
    }
  }
  
  dialogClose = async (op) => {
		this.setState({ dialog: { ...this.state.dialog, show: false } })
		if (op === 1) {
      if (this.deleteRow.nueva) {
        const { tableData } = this.state;
        tableData.rows = tableData.rows.filter(row => row.id !== this.deleteRow.id)
        this.props.elimianarGuia(this.deleteRow.id);
        this.setState({ tableData: { ...tableData, rows: tableData.rows, total: tableData.rows.length, rpp: tableData.rows.length } })
      } else {
        let Res = await Http.post(`${this.config.deleteUrl}`, this.deleteRow);
        if (!Res.error) {
          this.table(this.page, this.rpp, " ", this.orderBy);
        } else {
          return Toast.error(Res.errMsg || 'Error inesperado(999)')
        }
      }
		}
	}

  table = async(page = this.page, limit = this.rpp, q = this.q, orderBy = this.orderBy, order = this.order) =>{
		this.page = page; this.rpp = limit;
		this.setState({ loading: true })
		try {
			if (!q) {
				const urlParams = new URLSearchParams(window.location.search);
				q = urlParams.get('qt');
				let pages = urlParams.get('page');
				if (pages) {
					page = parseInt(pages);
					this.page = page;
				}
			}
			const nexo = this.config.dataUrl && this.config.dataUrl.includes('?') ? '&' : '?'
			let Res = await Http.get(`${this.config.dataUrl}${nexo}p=${page}&l=${limit}${q ? `&q=${q}` : ''}${orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`);
			Res.data.rows = Res.data.rows.map((row, i) => {
				for (let prop in row) {
					if (prop !== 'id' && isDate(row[prop])) {
						row[prop] = moment(row[prop]).format('D/M/YYYY HH:mm');
					}
				}
				return row;
			});

      let keep_rows = this.state.tableData.rows.filter(r => r.nueva);
      let new_rows = [...keep_rows, ...Res.data.rows ]

			this.setState({ tableData: { ...this.state.tableData, rows: new_rows, total: Res.data.total, q, page: this.page }, loading: false });
			return new_rows;
		} catch (error) {
			console.log(error);
			this.setState({ loading: false })
		}
		return [];
	}

  render() {

    return (
      <div>
        <this.TableRender />
      </div>
    )
  }
}

export default withRouter(EmbarqueGuias)